import axios from '../../../context/axiosConfig'
import { useState, useEffect } from 'react';
import { usePaginationPrzelewy } from '../../../context/PaginationContextPrzelewy';
const WygenerowaneGetList = () => {
    const {pagination, setPagination} = usePaginationPrzelewy()
    const [data, setData] = useState([])
    useEffect(() => {
      setPagination({...pagination, loading: true})
      const fetchData = async () => {
          const response = await axios.post("/przelewy/get/list/grouped", {
            pagination: pagination
          });
          if(pagination.current > (response.data.total / pagination.pagesize)){
            setPagination({...pagination, current: 1})  
          }
          setPagination({...pagination, loading: false})
          setData(response.data)
      }
      fetchData()
    },[pagination.current, pagination.pagesize, pagination.reload, pagination.generated, pagination.search])
    return data
  };
export default WygenerowaneGetList;